import PropTypes from "prop-types";
import Loader from "components/Loader";
import useAuth from "hooks/useAuth";

/** Gate for the /verification route — only waits out the auth-init flash
 * (not-logged-in users are already caught by the outer RouteGuard wrapping
 * the dashboard shell). Used to also redirect already-verified users to a
 * 404, but that meant a user approved while the page was open — or anyone
 * revisiting the link afterwards — hit a dead end instead of seeing their
 * request is done. VerificationPage itself now renders a "completed" state
 * for verified users instead, so this just needs to not block them. */
export default function RequireUnverified({ children }) {
  const { isInitialized } = useAuth();

  if (!isInitialized) {
    return <Loader />;
  }
  return children;
}

RequireUnverified.propTypes = {
  children: PropTypes.node,
};
